import { useNavigate } from 'react-router-dom';
import { fetchAndSetDeals } from 'components/views/FounderDeals/_helpers/founderDeals.resolvers';
import { useEffectAsync } from 'utils/useEffectAsync';
import SignalTable from 'components/global/SignalTable/SignalTable';
import FounderDealsRows from 'components/views/FounderDeals/_components/FounderDealsRows';
import { $form, $list } from 'signals/global.signals';
import SimpleCard from 'components/global/SimpleCard';
import UniversalInput from 'components/global/UniversalInput';
import { Button, Col, Row } from 'react-bootstrap';
import { handleChangeSearch } from 'components/views/FounderDeals/_helpers/founderDeals.events';
import PageTitle from 'components/global/PageTitle/PageTitle';
import withDismount from 'hocs/withDismount';
import FounderDealsDeleteModal from 'components/views/FounderDeals/_components/FounderDealsDeleteModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import FounderAddDealModal from 'components/views/FounderDeals/_components/FounderAddDealModal';
import FounderEditDealModal from 'components/views/FounderDeals/_components/FounderEditDealModal';

const Deals = () => {
  useEffectAsync(fetchAndSetDeals);
  const navigate = useNavigate();

  return (
    <>
      <PageTitle
        Buttons={(
          <Button
            className="bg-dark border-gray-900"
            variant="transparent"
            size="sm"
            onClick={() => handleShowModal('founder-add-deal')}
          >
            <FontAwesomeIcon icon={faPlus} className="me-8" size="sm" />
            Add Raise
          </Button>
        )}
      >
        Raises
      </PageTitle>
      <SimpleCard>
        <Row className="mb-24 align-items-center">
          <Col lg={12}>
            <UniversalInput
              name="search"
              value={$form.value.search}
              placeholder="Search raise by name..."
              className="border-0"
              customOnChange={handleChangeSearch}
            />
          </Col>
        </Row>
        <div className="signal-table-nowrap">
          <SignalTable
            headers={[
              { value: 'Name', key: 'name' },
              { value: 'Stage', key: 'investmentStage' },
              { value: 'Type of Raise', key: 'typeOfRaise' },
              { value: 'Created At', key: 'CreatedAt' },
              { value: 'Progress', key: 'progress' },
              { value: 'Actions', key: 'Actions' },
            ]}
            rows={FounderDealsRows({ data: $list.value.data || [] })}
            onRowClick={(row) => navigate(`/founder/deal/${row.id}`)}
          />
        </div>
      </SimpleCard>
      <FounderDealsDeleteModal />
      <FounderAddDealModal />
      <FounderEditDealModal />
    </>
  );
};

export default withDismount(Deals);
